import { createElement } from 'react';
const base_img_config = {
    '1': {
        blue: 'https://files.ztocwst.com/download/e69aa95c74194e24a0518fa6e754c422?isShow=true',
        green: 'https://files.ztocwst.com/download/1dc558b54fec462a8cc16fa725402ec2?isShow=true',
        yellow: 'https://files.ztocwst.com/download/5c26e68ac87f4673b0db7bfc840a5db6?isShow=true',
        red: 'https://files.ztocwst.com/download/09bd2bc5915a4b18adba276bb8af304a?isShow=true',
        purple: 'https://files.ztocwst.com/download/9770b7b06e5841c58e51e88b4ee43238?isShow=true',
    },
    '2': {
        blue: 'https://files.ztocwst.com/download/30a08a0f69ef4bea952cb9731520fa07?isShow=true',
        green: 'https://files.ztocwst.com/download/eef352357c774b9da1b36f56832189bf?isShow=true',
        yellow: 'https://files.ztocwst.com/download/e0b2fab92f974ee3a409322e43ac6f30?isShow=true',
        red: 'https://files.ztocwst.com/download/3a13767d0e3b43788a74b2a5f5777192?isShow=true',
        purple: 'https://files.ztocwst.com/download/fff91beecc984990a6261dcd0508651f?isShow=true',
    },
    '3': {
        blue: 'https://files.ztocwst.com/download/f0bc00d3f6f1415a962d1e6256026a77?isShow=true',
        green: 'https://files.ztocwst.com/download/d21886917680498ba1c9e12eec41d9b4?isShow=true',
        yellow: 'https://files.ztocwst.com/download/035daf0967514227a071fefd17faf2b1?isShow=true',
        red: 'https://files.ztocwst.com/download/072ef60518c04cfb940dcddb36d36ac8?isShow=true',
        purple: 'https://files.ztocwst.com/download/410d8edb827c43bebf58417859d4c41b?isShow=true',
    },
    '4': {
        blue: 'https://files.ztocwst.com/download/e791da095f8546aaa4eff1af681c9ac2?isShow=true',
        green: 'https://files.ztocwst.com/download/a01ef24d7bc24823998653d12b40f505?isShow=true',
        yellow: 'https://files.ztocwst.com/download/a529a8fb5aa94c8f96d04ec669bab521?isShow=true',
        red: 'https://files.ztocwst.com/download/76e1b106aded4b9c92ae631fd80d522a?isShow=true',
        purple: 'https://files.ztocwst.com/download/40e6392f0df64569957a2a8f88fff88d?isShow=true',
    },
    '5': {
        blue: 'https://files.ztocwst.com/download/c0898f3e3a7c4203934d17eaeff1c6e6?isShow=true',
        green: 'https://files.ztocwst.com/download/f67f2f1c5b5c4d1397f1b1de93de9863?isShow=true',
        yellow: 'https://files.ztocwst.com/download/a9a7aa4d89cd4292a4aad32a00adf20d?isShow=true',
        red: 'https://files.ztocwst.com/download/4ee19376144c48f193c689808bcaa087?isShow=true',
        purple: 'https://files.ztocwst.com/download/ba631c4696284737b872d1b3414eb5a6?isShow=true',
    },
    '6': {
        blue: 'https://files.ztocwst.com/download/02dd403b95984299a677c2e3278ac1a5?isShow=true',
        green: 'https://files.ztocwst.com/download/11fe543e38864b93852fd31aeefb6e9b?isShow=true',
        yellow: 'https://files.ztocwst.com/download/6677a87baa1548ccbe2b0fde3e8aacd4?isShow=true',
        red: 'https://files.ztocwst.com/download/9ee6674e3bbb4752a847c6d414088631?isShow=true',
        purple: 'https://files.ztocwst.com/download/e6d7a8be0cb14098a7a35f97ffffd3c7?isShow=true',
    },
    '7': {
        blue: 'https://files.ztocwst.com/download/b0dc4f82f3e14ddbb09a21019a77932d?isShow=true',
        green: 'https://files.ztocwst.com/download/a0774fbf2f014a6e823313911a01a4ac?isShow=true',
        yellow: 'https://files.ztocwst.com/download/d11967e4ceca4e29b410b520df379f46?isShow=true',
        red: 'https://files.ztocwst.com/download/7482186113954ce8a9fc97e1e5e16605?isShow=true',
        purple: 'https://files.ztocwst.com/download/84b366148df14f43b3af9ef764c80ec9?isShow=true',
    },
};
const Base = (props) => {
    const { type, color, width, height, content, footer } = props;
    const _type = base_img_config[type] || base_img_config['1'];
    const bgImg = _type[color] || _type.blue;
    const style = {
        background: `url("${bgImg}") center 0 / contain no-repeat`,
        ...props.style,
        width,
        height,
    };
    return (createElement("div", { className: `datav-indicator-base type_${type}`, style: style },
        createElement("div", { className: "content" }, content),
        footer ? createElement("div", { className: "footer" }, footer) : null));
};
export default Base;
